import { useSupabaseCallback } from "../../../server/supabase/hooks";
import {
  type MomentReviewLogEntry,
  type ReviewStep,
  SupabaseMomentReviewLogService,
} from "../server/supabase-moment-review-service";

export function useAddReviewStep(): (
  step: ReviewStep,
) => Promise<MomentReviewLogEntry | undefined> {
  return useSupabaseCallback(async ({ supabase }, step: ReviewStep) => {
    const { data, error } = await new SupabaseMomentReviewLogService(supabase).insert(step);
    if (error || !data) throw new Error(error?.message ?? "Could not save review step");
    return data;
  }, []);
}
